.empty {
	display: flex;
	flex-direction: column;
	gap: var(--spacing-2);
	align-items: center;
	justify-content: center;
	padding: var(--spacing-8) var(--spacing-4);
	text-align: center;
}

.icon {
	display: flex;
	align-items: center;
	justify-content: center;
	color: var(--colour-text-secondary);

	& > svg {
		inline-size: 2.5rem;
		block-size: 2.5rem;
	}
}

.title {
	margin: 0;
	font-size: var(--font-size-lg);
	font-weight: var(--font-weight-medium);
	color: var(--colour-text-primary);
}

.description {
	max-inline-size: 28rem;
	margin: 0;
	color: var(--colour-text-secondary);
}

.action {
	margin-block-start: var(--spacing-2);
}
